import { cn } from "@/lib/utils";
import { DialogTitle } from "@radix-ui/react-dialog";
import {
  ComponentProps,
  ComponentPropsWithoutRef,
  ComponentRef,
  forwardRef,
} from "react";
import { DialogContent, DialogFooter } from "./dialog";

export const CustomDialogFooter = ({
  className,
  ...props
}: ComponentProps<typeof DialogFooter>) => (
  <DialogFooter
    className={cn(
      "w-full flex flex-row align-center justify-around gap-4 sm:space-x-0 border-t p-6 bg-white",
      "relative before:absolute before:top-[-12px] before:inset-x-0",
      "before:h-3 before:bg-gradient-to-t before:from-black/5 before:to-transparent",
      className,
    )}
    {...props}
  />
);

export const CustomDialogContent = forwardRef<
  ComponentRef<typeof DialogContent>,
  ComponentPropsWithoutRef<typeof DialogContent>
>(({ className, ...props }: ComponentProps<typeof DialogContent>, ref) => (
  <DialogContent
    ref={ref}
    className={cn("p-0 bg-white overflow-hidden", className)}
    {...props}
  />
));

export const CustomDialogTitle = ({
  className,
  ...props
}: ComponentProps<typeof DialogTitle>) => (
  <DialogTitle
    className={cn("font-semibold text-lg px-6 py-4 border-b", className)}
    {...props}
  />
);
